var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvenience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "L_Illustration/Convenience") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "L_Illustration/Convenience",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E8E8E8",
    points: "1 18 23.001 18 23.001 3 1 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#2F2F36",
    points: "2 5.0004 2 14.0004 9 14.0004 9 18.0004 15 18.0004 15 14.0004 22 14.0004 22 5.0004"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#545466",
    points: "2 14 5 14 5 9 2 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#545466",
    points: "19 14 22 14 22 9 19 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#CEAD1F",
    points: "0 7 24 7 24 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#E4D336",
    points: "0 3 24 3 24 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#E4D336",
    points: "0 7 24 7 24 5 0 5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fillOpacity: 0.25,
    fill: "#000000",
    points: "7 7 17 7 17 1 7 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#D9CA45",
    points: "8 8 16 8 16 0 8 0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fillOpacity: 0.25,
    fill: "#000000",
    fillRule: "nonzero",
    x: 22,
    y: 7,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    fillOpacity: 0.25,
    fill: "#000000",
    fillRule: "nonzero",
    x: 1,
    y: 7,
    width: 1,
    height: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenience);
export default __webpack_public_path__ + "static/media/Convenience.ea955d6d01fd442148849ce24425a6de.svg";
export { ForwardRef as ReactComponent };